import { Type } from 'class-transformer';
import { CiramailActionItemsParameterDto } from './cira-mail-action-items-parameter-dto';

export class CiramailActionsParameterDto {
    @Type(() => CiramailActionItemsParameterDto)
    items: Array<CiramailActionItemsParameterDto>;

    emailAccount: string;
    clearCache: boolean;
}
